<ng-container *ngIf="isDisabled; then readonly; else editing"></ng-container>

<ng-template #readonly>
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Benutzer suchen"
           [ngModel]="value?.fullName"
           fullWidth
           [disabled]="true" />
    <button nbSuffix
            nbButton
            ghost
            *ngIf="value"
            (click)="goToUser()"
            nbTooltip="Zum Benutzer">
      <nb-icon icon="external-link-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>
</ng-template>

<ng-template #editing>
  <nb-form-field>
    <input nbInput
           type="text"
           #searchInput
           [ngModel]="value?.fullName"
           (ngModelChange)="filterText$.next($event);trigger$.next('reset')"
           placeholder="Benutzer suchen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth/>
    <button *ngIf="value" nbSuffix nbButton ghost (click)="clear()">
      <nb-icon icon="close-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="trigger$.next('loadMore')" [threshold]="50" [throttleTime]="100">
        <nb-list-item *ngFor="let user of users$ | async; trackBy: trackById" (click)="onSelectionChange(user)">
          <div class="user">
            <div class="name">{{ user.fullName }}</div>
            <div class="user-meta-info">{{ user.tenant.name }}</div>
            <div class="user-meta-info" *ngIf="user.teams">{{ getTeamText(user.teams) }}</div>
          </div>
        </nb-list-item>
      </nb-list>
    </div>
  </ng-template>
</ng-template>

